<template>
    <span class="layout-cookie-consent-wrapper" :class="appliedWrapperClasses">
        <slot v-if="cookiesAccepted"></slot>
        <span
            v-if="!cookiesAccepted"
            class="block relative"
        >
            <ImageOptimized
                v-if="disabledPoster"
                :src="disabledPoster"
                alt="Poster"
                class="absolute block inset-0 w-full h-full object-cover z-0 aspect-video"
            />
            <span class="relative p-4 sm:p-8 z-10 block bg-black bg-opacity-75 h-full">
                <span class="block mb-3 sm:mb-4">
                    {{ disabledMessage }}
                </span>
                <span class="relative z-10 flex flex-row space-x-3 pt-1">
                    <ButtonPrimary
                        buttonText="Enable Cookies"
                        :buttonClick="accept"
                    ></ButtonPrimary>
                    <ButtonPrimary
                        buttonColor="!bg-zinc-700 hover:!bg-zinc-600 !text-white !no-underline"
                        buttonText="Settings"
                        buttonRoute="/cookies"
                    ></ButtonPrimary>
                </span>
            </span>
        </span>
    </span>
</template>

<script>
import { mapState, mapActions } from 'pinia';

export default {
    name: 'LayoutCookieConsentWrapper',
    props: {
        type: {
            required: true,
            type: String,
            validator (type) {
                return ['video', 'audio', 'analytic', 'marketing', 'payment'].includes(type);
            },
        },
        disabledMessage: {
            required: false,
            type: String,
            default () {
                return 'Accept cookies to view the missing content.';
            },
        },
        disabledPoster: {
            required: false,
            type: String,
            default: null,
        },
    },
    emits: ['cookies-accepted'],
    computed: {
        ...mapState(useStoreCookies, {
            cookies: 'cookies'
        }),
        cookiesAccepted () {
            return !!this.cookies && !!this.cookies[this.type];
        },
        appliedWrapperClasses () {
            const classes = [];
            classes.push({'grid': true});
            if (!this.cookiesAccepted) {
                classes.push({'aspect-video': true});
                classes.push({'bg-zinc-950': true});
                classes.push({'text-white': true});
            } else if (this.cookiesAccepted) {
                classes.push({'relative': true});
                classes.push({'aspect-video': true});
                classes.push({'w-full': true});
            }
            return classes;
        },
    },
    methods: {
        accept () {
            this.$emit('cookies-accepted');
            this.acceptDefaultCookies();
        },
        ...mapActions(useStoreCookies, {
            acceptDefaultCookies: 'acceptDefaultCookies',
        }),
    },
};
</script>
